import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from './MenuAction';

const GetCartItem = (PlaceOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.WalmartNonCatalog,
            SDIConstants.methodNames.WalmartNonCatalog_Page_Load,
            JSON.stringify(PlaceOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "WalmartNonCatalog_Page_Load", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

const WorkOrderCheck = async (WorkOrderBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(WorkOrderBO),
            (data) => {
                if (data.success) {

                    if (data.response != "" && data.response != "[]" && data.response != [] && data.response) {
                        let contentData = { type: "workordercheckwal", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else {
                        let contentData = { type: "workorderfailwal", response: "failed" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};


const SaveNonCatalogEntry = (PlaceOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.WalmartNonCatalog,
            SDIConstants.methodNames.WalmartNonCatalog_SaveNonCatalogEntry,
            JSON.stringify(PlaceOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "WalmartNonCatalog_SaveNonCatalogEntry", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

const submitOrderBtnClick = (PlaceOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.WalmartNonCatalog,
            SDIConstants.methodNames.WalmartNonCatalog_submitOrder,
            JSON.stringify(PlaceOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SubmitOrderResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const DeleteCartItem = (DeleteItemBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.WalmartNonCatalog,
            SDIConstants.methodNames.WalmartNonCatalog_removecartItem,
            JSON.stringify(DeleteItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "WalmartNonCatalog_removecartItem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

const UpdateItemDesp = (PlaceOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.WalmartNonCatalog,
            SDIConstants.methodNames.WalmartNonCatalog_UpdateLineLevelItem,
            JSON.stringify(PlaceOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "WalmartNonCatalog_UpdateLineLevelItem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

export {
    submitOrderBtnClick,
    GetCartItem,
    SaveNonCatalogEntry,
    DeleteCartItem,
    UpdateItemDesp,
    WorkOrderCheck
}